import { BigNumber } from 'ethers'
import { parseEther } from 'ethers/lib/utils'

interface FormattedInputValue {
  inputValue: BigNumber
  inputValueStr: string
}

export function formatInputValue(valueStr: string): FormattedInputValue | null {
  const value: number = parseFloat(valueStr)

  let inputValue: BigNumber
  let inputValueStr: string

  if (isNaN(value) || value < 0 || valueStr.startsWith('00')) {
    inputValue = parseEther('0')
    inputValueStr = '0'
  } else {
    try {
      inputValue = parseEther(valueStr)

      // Do not allow number with leading zeros input like "01"
      if (valueStr.startsWith('0') && !valueStr.startsWith('0.')) {
        inputValueStr = value.toString()
      } else {
        inputValueStr = valueStr
      }
    } catch (err) {
      // Ether was too small. UI should not update
      return null
    }
  }

  return {
    inputValue,
    inputValueStr,
  }
}
